<!-- @format -->

@if (timesheet) {
  <div>
    <table
      id="time-entry"
      class="time-entry"
      [class.approvals-view]="isApprovalsView"
    >
      <tr class="date-row">
        <td class="entry-type"></td>
        <td class="date-block weekend">
          Sat
          <div class="dateEntry">{{ getTimesheetEntryDate(timesheet, 0) }}</div>
        </td>
        <td class="date-block weekend">
          Sun
          <div class="dateEntry">{{ getTimesheetEntryDate(timesheet, 1) }}</div>
        </td>
        <td class="date-block">
          Mon
          <div class="dateEntry">{{ getTimesheetEntryDate(timesheet, 2) }}</div>
        </td>
        <td class="date-block">
          Tue
          <div class="dateEntry">{{ getTimesheetEntryDate(timesheet, 3) }}</div>
        </td>
        <td class="date-block">
          Wed
          <div class="dateEntry">{{ getTimesheetEntryDate(timesheet, 4) }}</div>
        </td>
        <td class="date-block">
          Thu
          <div class="dateEntry">{{ getTimesheetEntryDate(timesheet, 5) }}</div>
        </td>
        <td class="date-block">
          Fri
          <div class="dateEntry">{{ getTimesheetEntryDate(timesheet, 6) }}</div>
        </td>
        <td></td>
      </tr>
      @for (
        entry of timesheet.entries;
        track entry.name;
        let entryIndex = $index
      ) {
        <tr
          class="entry-row"
          [class.remove-bottom-border]="
            entry.metadata.daysExceedingExpectedHours?.length ||
            entry.metadata.isInvalidCDOEntry
          "
        >
          <td class="entry-type">
            <div
              class="entry-type-label"
              [class.approvals-view]="isApprovalsView"
              (click)="onEditRow(entry, entryIndex)"
              [class.noPointer]="isNotAllowedEdit()"
            >
              <div
                class="entry-type-colour"
                [style.background-color]="getEntryTypeColor(entry)"
                [class.description]="
                  entry.metadata.description &&
                  entry.metadata.description.length > 0
                "
              ></div>
              <div
                class="entry-description-all"
                [class.unknownEntry]="!nameToEntryText(entry)"
              >
                <div>
                  <strong>{{ getEntryDisplayName(entry) }}</strong>
                </div>
                @if (entry.metadata.description && !entry.metadata.needsActingResubmit) {
                  <div class="entry-description">
                    <span>{{ entry.metadata.description }}</span>
                  </div>
                }
                @else if (entry.metadata.showActingWarning && !entry.metadata.needsActingResubmit) {
                  <div class="entry-description-warning">
                    <div class="warning-icon-bar">
                      <i class="fa-solid fa-circle-exclamation"></i>
                      <span>Attention required</span>
                    </div>
                    <div class="entry-description">
                      <span>Acting compensation cannot be applied until your Manager enters the Acting Details. Once Acting Details have been entered, please refresh the browser and resubmit this timesheet.</span>
                    </div>
                  </div>
                }
                @else if (entry.metadata.description && entry.metadata.needsActingResubmit) {
                  <div class="entry-description-warning">
                    <div class="warning-icon-bar">
                      <i class="fa-solid fa-circle-exclamation"></i>
                      <span>Resubmit required</span>
                    </div>
                    <div class="entry-description">
                      <span>{{ entry.metadata.description }}</span>
                    </div>
                  </div>
                }
                <!-- <div class="entry-description" *ngIf="entry.metadata.comments"> {{entry.metadata.comments}} </div> -->
              </div>
            </div>
          </td>
          @for (
            duration of entry.durations;
            track trackByFn(weekDayIndex);
            let weekDayIndex = $index
          ) {
            <td class="entry-box-cell">
              @if (lockTimeEntry || entry.metadata.disableEdit) {
                <div
                  class="entry-box-locked"
                  [ngbTooltip]="
                    (entry.name === 'Overtime' || entry.name === 'Council') &&
                    entry.durations![weekDayIndex] > 0
                      ? tooltip
                      : ''
                  "
                  [ngClass]="{
                    otToolTipInfo:
                      (entry.name === 'Overtime' || entry.name === 'Council') &&
                      entry.durations![weekDayIndex] > 0,
                  }"
                >
                  {{ formatNumberDisplay(duration) }}
                </div>
              }
              <ng-template #tooltip>
                <table
                  class="otToolTip"
                  [innerHTML]="getToolTip(entryIndex, weekDayIndex)"
                ></table>
              </ng-template>
              @if (!lockTimeEntry && !entry.metadata.disableEdit) {
                <input
                  class="entry-box entry-box-input"
                  [(ngModel)]="entry.durationsInDisplayFormat![weekDayIndex]"
                  (ngModelChange)="
                    convertToNumberAndUpdate($event, entryIndex, weekDayIndex)
                  "
                  (focusout)="handleFocusOut(entry, weekDayIndex)"
                  type="text"
                  (keypress)="
                    cleanInput(
                      $event,
                      false,
                      entry,
                      entry.durations,
                      weekDayIndex
                    )
                  "
                  (paste)="
                    cleanInput(
                      $event,
                      true,
                      entry,
                      entry.durations,
                      weekDayIndex
                    )
                  "
                  [class.greyInputText]="
                    isDayLongerThanZeroHours(entry, weekDayIndex)
                  "
                  onClick="this.select()"
                  [ngClass]="{
                    otToolTipInfo:
                      (entry.name === 'Overtime' || entry.name === 'Council') &&
                      entry.durations![weekDayIndex] > 0,
                  }"
                  [ngbTooltip]="
                    (entry.name === 'Overtime' || entry.name === 'Council') &&
                    entry.durations![weekDayIndex] > 0
                      ? tooltip
                      : entry.name === 'Overtime'
                        ? 'Enter your overtime hours excluding meal breaks. They will be automatically calculated for you.'
                        : ''
                  "
                />
              }
            </td>
          }
          @if (!isApprovalsView) {
            <td class="entry-box" [class.disabledBtns]="lockTimeEntry">
              <button
                (click)="deleteRow(entryIndex)"
                [disabled]="lockTimeEntry"
                class="button-removestyles"
              >
                <i class="fa-light fa-trash fa-2xl"></i>
              </button>
            </td>
          }
        </tr>
        @if (entry.metadata.daysExceedingExpectedHours?.length) {
          <tr
            class="entry-row-extension"
            [class.remove-bottom-border]="entry.metadata.isInvalidCDOEntry"
          >
            <td colspan="9">
              <span class="hours-error">
                Allocate the extra hour(s) to another row. You've exceeded your
                scheduled hours for
                {{ entry.metadata.daysExceedingExpectedHours | weekdayNames }}.
                <button
                  (click)="entry.metadata.daysExceedingExpectedHours = []"
                  class="button-removestyles"
                >
                  <i class="fa-sharp fa-solid fa-xmark"></i>
                </button>
              </span>
            </td>
          </tr>
        }
        @if (entry.metadata.isInvalidCDOEntry) {
          <tr class="entry-row-extension">
            <td colspan="9">
              <span class="hours-error">
                The number of hours for a CDO must be
                {{ getRegularDayHours() }}.
                <button
                  (click)="entry.metadata.isInvalidCDOEntry = false"
                  class="button-removestyles"
                >
                  <i class="fa-sharp fa-solid fa-xmark"></i>
                </button>
              </span>
            </td>
          </tr>
        }
        @if (
          entry.metadata.cdoShiftNotes &&
          entry.metadata.cdoShiftNotes.length > 0
        ) {
          <tr class="entry-row-extension">
            <td colspan="9">
              <span class="hours-cdoShift-info">
                {{ entry.metadata.cdoShiftNotes }}.
                <button
                  (click)="entry.metadata.cdoShiftNotes = ''"
                  class="button-removestyles"
                >
                  <i class="fa-sharp fa-solid fa-xmark"></i>
                </button>
              </span>
            </td>
          </tr>
        }
        @if (entry.metadata.isBankedTimeError) {
          <tr class="entry-row-extension">
            <td colspan="9">
              <span class="hours-error">
                The number of hours for a banked time entry must be a multiple
                of {{ getRegularDayHours() }}.
                <button
                  (click)="entry.metadata.isBankedTimeError = false"
                  class="button-removestyles"
                >
                  <i class="fa-sharp fa-solid fa-xmark"></i>
                </button>
              </span>
            </td>
          </tr>
        }
      }
      @for (metadata of timesheet.metadata; track metadata) {
        @if (metadata.bankedCDO) {
          <tr class="bankedCDO">
            <div class="bankedCDONotice">
              <span
                >{{ metadata.bankedCDO.description }}
                @if (!lockTimeEntry) {
                  <span class="bankCDOUndo" (click)="handleUndoBankCDO()"
                    >Undo?</span
                  >
                }
              </span>
            </div>
          </tr>
        }
      }
      @if (!isApprovalsView) {
        <div class="add-row-btn" [class.disabledBtns]="lockTimeEntry">
          <button (click)="onAddRow()" [disabled]="lockTimeEntry">
            <div class="add-row-circle"><span>+</span></div>
            <span>Add a row</span>
          </button>
        </div>
      }
      <tr class="total-hours" [class.approvals-view]="isApprovalsView">
        <td class="totalHoursHeading" [class.approvals-view]="isApprovalsView">
          TOTAL HOURS
          <div class="remainingHours">Remaining hours to allocate</div>
        </td>
        @for (
          entry of totalHoursEntered;
          track "entry" + $index;
          let i = $index
        ) {
          <td class="column-sums totalHoursTime">
            {{ formatNumberDisplay(totalHoursEntered[i]) }}
            <div class="remainingHours">
              {{ formatNumberDisplay(remainingToAllocate[i]) }}
            </div>
          </td>
        }
        <td></td>
      </tr>
      @if (showTooFewHoursError) {
        <tr>
          <td colspan="9">
            <span class="hours-error">
              Allocate all remaining hours before submitting your timesheet.
              <button
                (click)="showTooFewHoursError = false"
                class="button-removestyles"
              >
                <i class="fa-sharp fa-solid fa-xmark"></i>
              </button>
            </span>
          </td>
        </tr>
      }
      @if (showInvalidEntryError) {
        <tr>
          <td colspan="9">
            <span class="entry-error">
              Time categories with an "*" are no longer valid as your Profile
              has been updated e.g. You have been reclassified as an Auxiliary
              employee from a Regular Full Time employee. Please resubmit your
              timesheet with the appropriate time category.
              @if (!isApprovalsView) {
                <button
                  (click)="showInvalidEntryError = false"
                  class="button-removestyles"
                >
                  <i class="fa-sharp fa-solid fa-xmark"></i>
                </button>
              }
            </span>
          </td>
        </tr>
      }
    </table>
    @if (!isApprovalsView) {
      @if (hasSubmittedTimesheet() && lockTimeEntry && !isTimesheetApproved()) {
        <div class="submission-status">
          <i class="fa-regular fa-clock"></i>
          Pending approval
        </div>
      }
      @if (hasSubmittedTimesheet() && lockTimeEntry && isTimesheetApproved()) {
        <div class="submission-status">
          <i class="fa-sharp fa-solid fa-circle-check"></i>
          Timesheet approved
        </div>
      }
    }
    @if (!isApprovalsView) {
      <div class="row justify-content-end">
        <div class="col-4 d-flex justify-content-end">
          @if (!hasSubmittedTimesheet()) {
            <button
              type="button"
              [disabled]="isProcessingTimesheet"
              class="btn btn-outline-primary add-btn mx-2"
              (click)="processTimesheet('save')"
            >
              Save
            </button>
          }
          @if (!lockTimeEntry && !isEditingEmployeeTimesheet) {
            @if (!hasSubmittedTimesheet()) {
              <button
                type="submit"
                class="btn btn-primary submit-btn"
                [disabled]="isProcessingTimesheet"
                (click)="processTimesheet('submit')"
              >
                Submit
              </button>
            }
            @if (hasSubmittedTimesheet()) {
              <button
                type="submit"
                [disabled]="isProcessingTimesheet"
                class="btn btn-primary submit-btn"
                (click)="processTimesheet('submit')"
              >
                Update
              </button>
            }
          }
          @if (isEditingEmployeeTimesheet) {
			@if (isTimesheetSubmitOnly) {
				@if (!hasSubmittedTimesheet()) {
					<button
						type="submit"
            [disabled]="isProcessingTimesheet"
						class="btn btn-primary submit-btn"
						(click)="processTimesheet('submit')">
						Submit
					</button>
				}
				@if (hasSubmittedTimesheet()) {
					<button
						type="submit"
            [disabled]="isProcessingTimesheet"
						class="btn btn-primary submit-btn"
						(click)="processTimesheet('submit')">
						Update
					</button>
				}
			}
			@else {
				<button
				  class="btn btn-primary submit-btn"
          [disabled]="isProcessingTimesheet"
				  (click)="processTimesheet('approve')">
				  Update
				</button>
			}
          }
        </div>
      </div>
    }
  </div>
}
